import {
  Area,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { getOverlayColor, getOverlaySeriesKey } from '../constants';
import type { ChartRow } from '../types';
import {
  buildTrendTimeTicks,
  formatSecondLabel,
  formatTrendTooltipLabel,
  formatTrendTooltipMetric,
} from '../utils/trendZoom';

type TrendLineChartProps = {
  rows: ChartRow[];
  meanLabel: string;
  overlaySessionIds: number[];
  overlaySessionLabelById: Map<number, string>;
};

export function TrendLineChart({
  rows,
  meanLabel,
  overlaySessionIds,
  overlaySessionLabelById,
}: TrendLineChartProps) {
  const timeTicks = buildTrendTimeTicks(rows);

  if (rows.length === 0) {
    return null;
  }

  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer>
        <LineChart data={rows}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis
            type='number'
            dataKey='second'
            domain={['dataMin', 'dataMax']}
            ticks={timeTicks}
            tickFormatter={value => formatSecondLabel(Number(value))}
          />
          <YAxis />
          <Tooltip
            labelFormatter={formatTrendTooltipLabel}
            formatter={(value, name) => [
              formatTrendTooltipMetric(value as number | string),
              String(name),
            ]}
          />
          <Legend />
          <Area
            type='monotone'
            dataKey='stdUpper'
            stroke='none'
            fill='rgba(59,130,246,0.14)'
            activeDot={false}
          />
          <Area
            type='monotone'
            dataKey='stdLower'
            stroke='none'
            fill='rgba(255,255,255,0)'
            activeDot={false}
          />
          <Line
            type='monotone'
            dataKey='mean'
            stroke='#1d4ed8'
            strokeWidth={2.1}
            dot={false}
            name={meanLabel}
          />
          {overlaySessionIds.map(sessionId => (
            <Line
              key={`overlay-session-${sessionId}`}
              type='monotone'
              dataKey={getOverlaySeriesKey(sessionId)}
              stroke={getOverlayColor(sessionId)}
              strokeWidth={1.4}
              strokeOpacity={0.72}
              dot={false}
              name={
                overlaySessionLabelById.get(sessionId) ??
                `Sessione ${sessionId}`
              }
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
